export default {
  TT107: 0,
  CompositeSample: 1,
};
